import { Component } from '@angular/core';
import { BannerAppComponent } from '../../../components/banner-app/banner-app.component';
import { FooterAppComponent } from '../../../components/footer-app/footer-app.component';

@Component({
  selector: 'sura-informacion-fasecolda',
  standalone: true,
  imports: [BannerAppComponent, FooterAppComponent],
  templateUrl: './informacion-fasecolda.component.html',
  styleUrl: './informacion-fasecolda.component.scss',
})
export class InformacionFasecoldaComponent {
  goToSura(): void {
    window.location.href = 'https://www.sura.co/';
  }
}
